import { stringToHash } from "./sts";

(function () {
    window.stringToHash = stringToHash;
    window.$tp = window.$tp || {};
    window.$tp.hashedHost = window.stringToHash(window.location.host.toLowerCase());
}());
